import { BasicProperties } from "./BasicProperties";
import { TextField, KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { getLogger } from "@goodgamestudios/logger";
import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Stage = createjs.Stage;

const logger = getLogger("CoreJS.FlashUIComponent")

export class FlashUIComponent {
    public static readonly NAME: string = "FlashUIComponent";
    protected properties: BasicProperties;
    protected isInitialized: boolean = false;
    private _disp: DisplayObject;
    private _hasStageListener: boolean = false;

    constructor(disp: DisplayObject) {
        this._disp = disp;
        this._disp.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));
    }

    /**
     * is executed when displayObject added to Stage
     * initialized the component and added Eventlistener
     */
    protected onAddedToStage(event: Event): void {
        if (!this.isInitialized) {
            this.init();
            this.isInitialized = true;
        }

        this.applyProperties();
        this.updatePosition();

        this._disp.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));

        // No Check before them !!!! There could bo other functions on them!!
        this._disp.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        this._disp.addEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.onMouseUp));
        this._disp.addEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.onMouseDown));
        this._disp.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOver));
        this._disp.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOut));
        this._disp.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemovedFromStage));

    };

    /**
     * Search recursively for textfields
     */
    private findTextFields(container: Container): any[] {
        let result: any[] = [];

        for (let i: number = 0; i < container.numChildren; i++) {
            let disp: DisplayObject = container.getChildAt(i);

            if (disp instanceof TextField) {
                result.push(disp);
            }
            else if (disp instanceof Container) {
                let childResult: any[] = this.findTextFields((<Container>disp));
                result = result.concat(childResult);
            }
        }
        return result;
    }

    protected onRollOut(event: MouseEvent): void {
    };

    protected onRollOver(event: MouseEvent): void {
    };

    protected onClick(event: MouseEvent): void {
    };

    protected onMouseUp(event: MouseEvent): void {
    };

    protected onMouseDown(event: MouseEvent): void {
    };

    /*
     To get the key name, check event.params array
     [0] - key name
     [1] - modifier/modifiers
     */
    protected onKeyUp(event: KeyboardEvent): void {
        // react on key events
    };

    protected onRemovedFromStage(event: Event): void {
        this.destroy();
        // reset();
    };

    public /*final*/ reset(): void {
        this.destroy();
        this.init();
        this.applyProperties();
    }

    /**
     * Use this method to initialize all static stuff
     * Only for overriding, do NOT call init() yourself!
     */
    protected init(): void {
    }

    /**
     * Call this method, if dynamic properties of the dialog should be
     * reinitialized. Override applyProperties() to process these
     * dynamic properties.
     *
     * @param properties
     *
     */
    public /*final*/ setProperties(properties: BasicProperties): void {
        this.properties = properties;

        if (this.isInitialized) {
            this.applyProperties();
        }
    }

    /**
     * Override this method to customize your component based on the component's
     * current properties. Is called by setProperties, so you shouldn't have to
     * call it yourself.
     *
     */
    protected applyProperties(): void {
        // use properties to customize component
    }

    /**
     * update displayObject position
     */
    protected onResize(event: any = null): void {
        this.updatePosition();

        // problem: enlarging the canvas also happens with this event and the order might be wrong;
        // we have to call updatePosition once again in the next frame to make sure it was correctly adjusted to
        // the new window size
        let me: FlashUIComponent = this;
        setTimeout(() => {
            if ( me.disp && me.isVisible() ) {
                me.updatePosition();
            }}, 1);
    }

    /**
     * add Keyboard and Resize-Eventlistener and shown displayobject
     */
    public show(): void {
        if (this._disp) {
            if (this._disp.stage && !this._hasStageListener) {
                this.disp.stage.addEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUp));
                window.addEventListener('resize', this.bindFunction(this.onResize), false);
            }
            this._disp.visible = true;
            this.onResize(null);
            this._hasStageListener = true;
        }
    }

    protected update(): void {
    }

    /**
     * remove Keyboard and Resize-Eventlistener and unshown displayobject
     */
    public hide(): void {
        if (this._disp) {
            if (this._disp.stage) {
                this._disp.stage.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUp));
            }
            this._disp.visible = false;
        }
        window.removeEventListener('resize', this.bindFunction(this.onResize), false);
        this._hasStageListener = false;
    }

    public isVisible(): boolean {
        return this._disp.visible;
    }

    public toggleVisibility(): void {
        this.isVisible() ? this.hide() : this.show();
    }

    public updatePosition(): void {
        // set components position
    }

    public /*final*/ get disp(): DisplayObject {
        return this._disp;
    }

    public set disp(value: DisplayObject) {
        this._disp = value;
    }

    /**
     * remove all event listeners
     */
    public destroy(): void {
        if (this._disp == null) {
            return;
        }
        this._disp.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemovedFromStage));

        if (this._disp.hasEventListener(MouseEvent.CLICK)) {
            this._disp.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        }
        this._disp.removeEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.onMouseUp));
        this._disp.removeEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.onMouseDown));
        this._disp.removeEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOver));
        this._disp.removeEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOut));

        this.disp.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUp));
        window.removeEventListener('resize', this.bindFunction(this.onResize), false);
        //this.__stage.removeEventListener(Event.RESIZE, this.onResize);
        // this._disp.parent.removeChild(this._disp);
    }
}

